angular.module('omcDialog', ['ngSanitize']);
